export default __webpack_public_path__ + "static/media/iconSad.60b2a7c4.svg";